export enum ChannelEvents {
  OrderNotificationAdded = 'order_notification_added',
  OrderNotificationUpdated = 'order_notification_updated',
  OrderPresenceChange = 'order_presence_change',
  QcReportUpdated = 'qc_report_updated'
}
